import React from 'react';
import MarketShare from 'components/partials/charts/ShareChart';
import { groupDataByField, sortDataByField } from 'helpers/productionHelper';

export const FRAME_INSPECTION_STATIONS = [22, 57, 92];
export const FRAME_HANGING_STATIONS = [1, 43, 44, 45];
export const BEADING_STATIONS = [4, 13, 15];
export const SASH_ASSEMBLY = [88, 59, 60, 61];

export const colors = ['primary', 'success', 'info', 'warning', 'secondary', 'danger', 'gray-400', 'dark', 'purple', 'pink', 'orange', 'blue'];

export const transformProductionItemsData = productionItems => {
  const result = [];
  const frameInspection = productionItems.filter(i => FRAME_INSPECTION_STATIONS.includes(i.stationId));

  const frameHanging = productionItems.filter(i => FRAME_HANGING_STATIONS.includes(i.stationId));

  const beading = productionItems.filter(i => BEADING_STATIONS.includes(i.stationId));

  const sashAssembly = productionItems.filter(i => i.sashNo > 0 && SASH_ASSEMBLY.includes(i.stationId));

  result.push({ key: 'frameInspection', value: frameInspection });
  result.push({ key: 'frameHanging', value: frameHanging });
  result.push({ key: 'beading', value: beading });
  result.push({ key: 'sashAssembly', value: sashAssembly });

  return result;
};

export const generateStationGroup = key => {
  let result = '';
  switch (key) {
    case 'frameInspection':
      result = 'Frame Inspection';
      break;
    case 'frameHanging':
      result = 'Frame Hanging';
      break;
    case 'beading':
      result = 'Beading';
      break;
    case 'sashAssembly':
      result = 'Sash Assembly';
      break;
    default:
      result = '';
      break;
  }
  return result;
};

export const removeDuplicated = data => {
  const arr = [];
  data.reduce((acc, curr) => {
    if (
      acc.findIndex(item => {
        return (
          item.headerId > 0 &&
          item.frameId > 0 &&
          item.headerId == curr.headerId &&
          item.frameId == curr.frameId &&
          item.sashNo == curr.sashNo &&
          item.sashNo > 0 &&
          curr.sashNo > 0
        );
      }) === -1
    ) {
      acc.push(curr);
      arr.push(curr);
    }
    return acc;
  }, []);

  return arr;
};

export const transformPieChartData = (source, groupByField, key) => {
  let data = source;
  if (key == 'sashAssembly') {
    data = removeDuplicated(data);
  }
  const sorted = sortDataByField(data, groupByField);
  const grouped = groupDataByField(sorted, groupByField);
  return Object.keys(grouped).map((item, index) => {
    return {
      value: grouped[item].length,
      name: item,
      color: colors[index % colors.length]
    };
  });
};

export const groupBoxItems = data => {
  return (
    Array.isArray(data) &&
    data.length > 0 &&
    data.reduce((acc, item) => {
      const key = item.isBox ? 'Boxes' : 'Items';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {})
  );
};

export const transformPieChartForBoxes = (data, groupByField) => {
  const results = [];
  const sorted = sortDataByField(data, groupByField);
  const grouped = groupDataByField(sorted, groupByField);
  Object.keys(grouped).map((item, index) => {
    const itemsGrouped = groupBoxItems(grouped[item]);
    if (itemsGrouped) {
      Object.keys(itemsGrouped).map(detail => {
        results.push({
          value: itemsGrouped[detail].length,
          name: `${item} ${detail}`,
          color: colors[index % colors.length]
        });
      });
    }
  });
  return results;
};

export const transformPieChartStationDetail = data => {
  const grouped = groupDataByField(data, 'userName');
  return Object.keys(grouped).map((item, index) => {
    return {
      value: grouped[item].length,
      name: item,
      color: colors[index % colors.length]
    };
  });
};

export const generateStationDetail = (stationGroup, prefix, key) => {
  const sorted = sortDataByField(stationGroup, 'stationName');
  const grouped = groupDataByField(sorted, 'stationName');

  if (Object.keys(grouped).length > 0) {
    return Object.keys(grouped).map((station, ind) => (
      <div key={ind}>
        <MarketShare
          data={transformPieChartStationDetail(grouped[station])}
          radius={['95%', '83%']}
          title={prefix ? prefix + ' ' + station : station}
          summary={key == 'sashAssembly' ? removeDuplicated(grouped[station])?.length : ''}
        />
      </div>
    ));
  }
  return <></>;
};
